export default "__VITE_ASSET__z$FqymVD__"